// Eskom PARCC — "review summary by division" export (Lindiwe feedback Jun 23 2026,
// 2a). All findings grouped by division for Team Leads / Managers / Admin.
//
// Reuses the findings-register column model (buildFindingsSheet), which already
// carries a Division column AND the Reviewed state — so the workbook matches the
// register column-for-column; we just SORT by division (then reference) so each
// division's findings sit together. Scoping (role + division) is the caller's job:
// pass the findings the user is entitled to see. Pure — no XLSX, no DOM.
import type { FindingRead } from '../../lib/db';
import { buildFindingsSheet } from '../exports/buildFindingsSheet';
import type { TxByRef } from '../exports/buildFindingsCsv';
import { canonicalDivision } from '../../domain/divisions';

export function buildDivisionalFindingsSummary(
  findings: readonly FindingRead[],
  txByRef: TxByRef,
): string[][] {
  // Sort by CANONICAL division so raw-data spelling variants (ICT / Tactical / Gx)
  // sit together as one block, not two (owner feedback Aug 2026).
  const divisionOf = (f: FindingRead): string =>
    canonicalDivision(txByRef.get(f.referenceNo ?? '')?.division);
  const sorted = [...findings].sort((a, b) => {
    const da = divisionOf(a);
    const db = divisionOf(b);
    if (da !== db) return da.localeCompare(db);
    return (a.referenceNo ?? '').localeCompare(b.referenceNo ?? '', undefined, { numeric: true });
  });
  return buildFindingsSheet(sorted, txByRef);
}
